export default {
	'please-select-an-account': 'Please select an account',
	'show-archived': 'Show archived',
}